<template>
    <div class="inquire" v-cloak>
      <div class="data-bg">
      <app-header></app-header>
        <div class="data-banner">
          <div class="data-title-box">
            <p class="data-title"><span>{{ $t('xdata.Nav_idcsjzx') }}</span></p>
            <span class="data-sub"></span>
          </div>
          </div>
      </div>
      <div class="u-flex u-flex-center data-content">
        <data-item 
          :title="$t('xdata.Dat_fwqzy')"
          :sub="$t('xdata.Dat_fwqzyt1')"
          type="center"
        >
        </data-item>
        <data-item
          :title="$t('xdata.Dat_sjzx')"
          :sub="$t('xdata.Dat_sjzxt1')"
          type="center"
        >
        </data-item>
        <data-item
          :title="$t('xdata.Dat_cloud')"
          :sub="$t('xdata.Dat_cloudt1')"
          type="center"
        >
        </data-item>
        <data-item
          :title="$t('xdata.Dat_qqdk')"
          :sub="$t('xdata.Dat_qqdkt1')"
          type="center"
        >
        </data-item>
      </div>
      <div class="icome-bg">
        <div class="icome-box u-flex u-flex-center">
          <div class="icome-item u-flex u-flex-column u-flex-xy-center animated slideInLeft">
            <div class="icome-img-box">
              <img src="@/assets/img/data/tp6.png" />
            </div>
            <span>{{ $t('xdata.Dat_glpt') }}</span>
            <!-- 高性能计算资源管理平台 -->
          </div>
          <div class="icome-item u-flex u-flex-column u-flex-xy-center  animated flipInY">
            <div class="icome-img-box">
              <img src="@/assets/img/data/tp7.png" />
            </div>
            <span>{{ $t('xdata.Dat_jkfx') }}</span>
            <!-- 系统资源监控分析系统 -->
          </div>
          <div class="icome-item u-flex u-flex-column u-flex-xy-center animated slideInRight">
            <div class="icome-img-box">
              <img src="@/assets/img/data/tp8.png" />
            </div>
            <span>{{ $t('xdata.Dat_yglpt') }}</span>
            <!-- 云计算资源管理平台 -->
          </div>
        </div>
      </div>
      <div class="data-list-box">
          <div class="data-list-bg">
            <div class="data-list">
              <div class="data-list-item u-flex u-flex-between">
                <img src="@/assets/img/data/xint.jpg" class="data-list-item-right" v-if="lang == 'zh-CN' "/>
                <img src="@/assets/img/data/xint_en.jpg" class="data-list-item-right" v-else/>
                <div class="data-list-item-left">
                  <p class="data-list-item-name">{{ $t('xdata.Dat_xtsj') }}</p>
                  <p class="data-list-item-sub data-list-item-mb">{{ $t('xdata.Dat_xtsjt1') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_xtsjt2') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_xtsjt3') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_xtsjt4') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_xtsjt5') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_xtsjt6') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_xtsjt7') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="data-list-bg">
            <div class="data-list">
              <div class="data-list-item u-flex u-flex-between">
                <div class="data-list-item-left">
                  <p class="data-list-item-name">{{ $t('xdata.Dat_shhl') }}</p>
                  <p class="data-list-item-sub data-list-item-mb">{{ $t('xdata.Dat_shhlt1') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shhlt2') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shhlt3') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shhlt4') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shhlt5') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shhlt6') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shhlt7') }}</p>
                </div>
                <img src="@/assets/img/data/hulan.png" class="data-list-item-right"/>
              </div>
            </div>
          </div>
          <div class="data-list-bg">
            <div class="data-list">
              <div class="data-list-item u-flex u-flex-between">
              <img src="@/assets/img/data/nanhui.png" class="data-list-item-right"/>
              <div class="data-list-item-left">
                <p class="data-list-item-name">{{ $t('xdata.Dat_shdx') }}</p>
                <p class="data-list-item-sub data-list-item-mb">{{ $t('xdata.Dat_shdxt1') }}</p>
                <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shdxt2') }}</p>
                <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shdxt3') }}</p>
              </div>
            </div>
            </div>
          </div>
          <div class="data-list-bg">
            <div class="data-list">
                <div class="data-list-item u-flex u-flex-between">
                  <div class="data-list-item-left">
                  <p class="data-list-item-name">{{ $t('xdata.Dat_shlt') }}</p>
                  <p class="data-list-item-sub data-list-item-mb">{{ $t('xdata.Dat_shltt1') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shltt8') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shltt2') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shltt3') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shltt4') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shltt5') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shltt6') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_shltt7') }}</p>
                </div>
                <img src="@/assets/img/data/zhoupu.png" class="data-list-item-right"/>
              </div>
            </div>
          </div>
          <div class="data-list-bg">
            <div class="data-list">
              <div class="data-list-item u-flex u-flex-between">
              <img src="@/assets/img/data/pd.png" class="data-list-item-right"/>
              <div class="data-list-item-left">
                <p class="data-list-item-name">{{ $t('xdata.Dat_dlsd') }}</p>
                <p class="data-list-item-sub data-list-item-mb">{{ $t('xdata.Dat_dlsdt1') }}</p>
              </div>
            </div>
            </div>
          </div>
          <div class="data-list-bg">
            <div class="data-list">
                <div class="data-list-item u-flex u-flex-between">
                  <div class="data-list-item-left">
                  <p class="data-list-item-name">{{ $t('xdata.Dat_obs') }}</p>
                  <p class="data-list-item-sub data-list-item-mb">{{ $t('xdata.Dat_obst1') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_obst2') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_obst3') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_obst4') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_obst5') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_obst6') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_obst7') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_obst8') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_obst9') }}</p>
                </div>
                <img src="@/assets/img/data/obs.png" class="data-list-item-right"/>
              </div>
            </div>
          </div>
          <div class="data-list-bg">
            <div class="data-list">
              <div class="data-list-item u-flex u-flex-between">
              <img src="@/assets/img/data/ys.png" class="data-list-item-right"/>
              <div class="data-list-item-left">
                <p class="data-list-item-name">{{ $t('xdata.Dat_ystbe') }}</p>
                <p class="data-list-item-sub data-list-item-mb">{{ $t('xdata.Dat_ystbet1') }}</p>
              </div>
            </div>
            </div>
          </div>
          <div class="data-list-bg">
            <div class="data-list">
                <div class="data-list-item u-flex u-flex-between">
                  <div class="data-list-item-left">
                  <p class="data-list-item-name">{{ $t('xdata.Dat_hk') }}</p>
                  <p class="data-list-item-sub data-list-item-mb">{{ $t('xdata.Dat_hkt1') }}:</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_hkt2') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_hkt3') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_hkt4') }}</p>
                  <p class="data-list-item-sub">▪ {{ $t('xdata.Dat_hkt5') }}</p>
                </div>
                <img src="@/assets/img/data/hk.png" class="data-list-item-right"/>
              </div>
            </div>
          </div>
        </div>
      <app-footer></app-footer>
    </div>
  </template>
  
  <script>
  
import Header from "@/components/header";
import Footer from "@/components/footer";
import DataItem from "@/components/dataItem";

export default {
    components: {
      "app-header": Header,
      "app-footer": Footer,
      "data-item": DataItem,
    },
    name: "service",
    data() {
      return {
        lang:''
      };
    },
    created(){
      this.lang = localStorage.getItem('lang') 
    },
    mounted() {
    },
    methods: {
    
    }
  };
  </script>
  <style scoped >
    .data-bg {
      width: 100%;
      background: url(../../assets/img/data_bg.jpg) no-repeat fixed center center / 100% auto;
    }
    .data-banner{
      height: 300px;
      background: rgba(0, 0, 0, 0.3);
    }
    .data-title-box{
      padding-top: 60px;
      width: 1200px;
      margin: 0 auto;
    }
    .data-title{
      font-size: 32px;
      color: #fff;
      margin-bottom: 20px;
    }
    .data-sub{
      font-size: 14px;
      display: inline-block;
      width: 70%;
      color: #fff;
      line-height: 1.5;

    }
    .data-content{
      width: 1200px;
      background: #fff;
      margin: 50px auto;
    }
    .data-content .data-item-msg{
      display: inline-block;
      text-align: center;
    }
    .data-item:last-of-type{
      margin-right: 0px;
    }
    .data-list-box{
      padding: 50px 0 100px;
      background: #f4f4f4;
    }
    .data-list-bg{
      padding: 50px 0 80px;
    }
    .data-list{
      width: 1200px;
      padding-left: calc((100vw - 1200px) / 2);
      padding-right: 0px;
      background: #fff;
    }
    .data-list-bg:nth-of-type(2n){
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
    .data-list-bg:nth-of-type(2n) .data-list{
      padding-right: calc((100vw - 1200px) / 2);
      padding-left: 0px;
    }
    .data-list-item{
      padding: 20px 0;
    }
    .data-list-item:last-of-type{
      border-bottom: none;
    }
    .data-list-item-left{
      width: 700px;
      padding: 0 40px;
      box-sizing: border-box;
    }
    .data-list-item-right{
      width: 500px;
      position: relative;
      bottom: -70px;
      left: -50px;
      border: 1px solid #f4f4f4;
    }
    .data-list-bg:nth-of-type(2n) .data-list-item-right{
      left: 50px;
    }
    .data-list-item-name{
      font-size: 24px;
      margin-bottom: 40px;
      font-weight: bold;
      position: relative;
      margin-top: 20px;
    }
    .data-list-item-name::after{
      content: '';
      display: block;
      position: absolute;
      bottom: -10px;
      left: 0px;
      width: 100px;
      height: 4px;
      border-radius: 4px;
      background: #009DE4;
    }
    .data-list-item-sub{
      line-height: 1.5;
    }
    .data-list-item-mb{
      margin-bottom: 20px;
    } 
    .icome-box{
      width: 1200px;
      margin: 0 auto;
      padding: 80px 0 0;
    }
    .icome-bg{
      background: #f4f4f4;
      color: rgb(41, 57, 99);
    }
    .icome-item{
      width: 160px;
      height: 160px;
      border-radius: 50%;
      border: 1px solid #aaa;
      background: #fff;
      box-shadow: 0px 0px 10px 0px rgba(41, 57, 99, 0.5);
    }
    .icome-item img{
      border-radius: 50%;
      width: 60px;
      height: 60px;
    }
    .icome-item:nth-of-type(2){
      margin: 0 120px;
    }
    .icome-item span{
      font-size: 14px;
      text-align: center;
      color: #333;
      display: inline-block;
      height: 40px;
      font-weight: bold;
    }
  </style>
  


// WEBPACK FOOTER //
// src/views/services/dataCenter.vue